import { useQuery } from '@tanstack/react-query';

import RecommendationSettingsService, {
  RecommendationSetting,
  RecommendationSettingType,
} from '@/services/RecommendationSettingsService';

export const RECOMMENDATION_SETTING_QUERY_KEY = ['recommendation-setting'];

export function useGetRecommendationSetting(
  type: RecommendationSettingType,
  enabled = true,
) {
  const { data, isFetching, isError } = useQuery<RecommendationSetting>({
    queryKey: [...RECOMMENDATION_SETTING_QUERY_KEY, type],
    enabled,
    queryFn: () => RecommendationSettingsService.findByType(type),
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return {
    recommendationSetting: data,
    isLoading: isFetching,
    isError,
  };
}
